import { Ba1300Class } from "../ba1300/ba1300-class";
import { FileAttachmentClass } from "../../Class/common/file-attachment/file-attachment-class";

export class ADM0009Class {
    ////////
NotificationId :number;
FkCompId :number;
FkCategoryId :number;
DocType: string;
EmpNo :string;
EmployeeName :string;
NotificationDate:Date;
NotificationContent :string;
LocateUrl :string;
NotificationUserId :number;
FkNotificationId:number;
FkEmpId :number;
CategoryId :number;
CategeoryName :string;
Active :number;
EmailRequires: number;     
EmployeeList:  Array<Ba1300Class> = [];
AttachmentList:  Array<FileAttachmentClass> = [];
Title:string;
PendingCount:number;

SendViaPersonalEmail:number;
SendViaOfficialEmail:number;
PageName:string;
Portal:number;

}
